<template>
  <div>
    <form-header
      :title="$t('ObjectsSelected')"
      @close="$emit('closeForm')"
      :is-multi-select="isMultiSelect"
      :active-tab-layer="activeTabLayer"
    />

    <v-tabs
      v-if="numberOfTabs > 0"
      :value="activeTab"
      background-color="transparent"
      show-arrows
      centered
      height="40px"
      :key="height + width"
    >
      <v-tabs-slider color="accent" :key="height + width" />

      <v-tab
        v-for="(tab, index) in tabs"
        :key="tab.label"
        style="text-transform: none; font-size: 12px"
        :disabled="disableTabs"
        @change="$emit('startTabChange', index)"
      >
        {{ $tc(getTranslationKey(tab.layer), 2) }}
      </v-tab>
    </v-tabs>

    <multi-selection-tab
      v-if="activeTabLayer !== undefined"
      :max-height="height"
      :layer="activeTabLayer"
      :can-modify-objects="canModifyObjects"
      :can-generate-request="canGenerateRequest"
      :can-highlight-objects="canHighlightObjects"
      @loadingObjects="disableTabs = $event"
    />
    <v-layout
      justify-center
      v-if="showWarning && canModifyObjects"
      style="padding-bottom: 10px; background-color: #f0f0ef"
    >
      <div class="message">
        <v-icon color="#515358" size="12" class="pr-2">warning</v-icon>
        {{ $t("WarningMultiSelectFieldsDepend") }}
        <br />
        {{ $t("WarningMultiSelectEditIndividual") }}
      </div>
    </v-layout>
  </div>
</template>

<script>
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
import MultiSelectionTab from "@/components/Home/Forms/MultiSelectionForm/MultiSelectionTab";
import FormHeader from "@/components/Home/Forms/_Molecules/FormHeader";
import { bus } from "@/main";
import { mapActions } from 'vuex';
export default {
  name: "MultipleObjectsSelectedWindow",
  components: { FormHeader, MultiSelectionTab, WindowHeaderButton },

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    activeTab: {
      type: Number,
      required: true,
    },

    height: {
      type: Number,
    },

    width: {
      type: Number,
    },

    canModifyObjects: {
      type: Boolean,
      default: true,
    },

    canGenerateRequest: {
      type: Boolean,
      default: false,
    },

    canHighlightObjects: {
      type: Boolean,
      default: false,
    },

    isMultiSelect: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      disableTabs: false,

      showWarning: false,
    };
  },

  computed: {
    /**
     * Total number of tabs.
     * @returns {number}
     */
    numberOfTabs() {
      return this.tabs.length;
    },

    /**
     * Name of the layer of the active tab.
     * @returns {undefined|String}
     */
    activeTabLayer() {
      if (this.numberOfTabs > 0) {
        return this.tabs[this.activeTab].layer;
      } else return undefined;
    },
  },

  mounted() {
    bus.$on("updateMode", (value) => {
      this.showWarning = value;
    });
    
  },

  destroyed() {
    bus.$off("updateMode");
  },



  methods: {
    
    getTranslationKey(layer) {
      return this.$store.getters.getLayerTranslationKey(layer);
    },
  },
};
</script>

<style scoped>
.message {
  color: #515358;
  padding: 0 0 4px 0;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/MultipleObjectsSelectedWindow.vue